var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"dragover":function($event){$event.preventDefault();return _vm.handleDragOver($event)},"dragleave":function($event){$event.preventDefault();return _vm.handleDragLeave($event)},"drop":function($event){$event.preventDefault();return _vm.handleDrop($event)}}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c84c0b20","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DragView.vue
// module id = null
// module chunks = 